<h1 mat-dialog-title>Select layer from My Layers</h1>

<mat-dialog-content>
	@if (loading) {
		<mat-spinner diameter="30" mode="indeterminate"></mat-spinner>
	} @else if (mapLayers?.length) {
		<mat-form-field subscriptSizing="dynamic" class="w-100">
			<mat-select [(ngModel)]="mapLayer" placeholder="Choose the layer">
				@for (layer of mapLayers; track $index) {
					<mat-option [value]="layer">{{layer.name}} ({{layer.type}})</mat-option>
				}
			</mat-select>
		</mat-form-field>
	} @else {
		<p>
			There are no more layers available to be added.
		</p>
	}
		<p class="pt-16 text-muted">
			To add layers to your My Layers list, please navigate to basemap selector on the main dashboard. In basemap
			selector on the bottom left of the map window you'll see an "+" option to add a layer.
			<br>
			Define all custom map layers there and they'll appear in this list.
		</p>
</mat-dialog-content>

<mat-dialog-actions>
	<button mat-stroked-button mat-dialog-close>
		Cancel
	</button>
	@if (mapLayers?.length) {
		<button mat-flat-button
				[disabled]="!mapLayer"
				[mat-dialog-close]="mapLayer">
			Add Layer
		</button>
	}
</mat-dialog-actions>
